export default __webpack_public_path__ + "img/2.efb1f8fc.jpg";